import { render } from "./ProposalSequence.vue?vue&type=template&id=8dddcf88&scoped=true"
import script from "./ProposalSequence.vue?vue&type=script&lang=js"
export * from "./ProposalSequence.vue?vue&type=script&lang=js"

import "./ProposalSequence.vue?vue&type=style&index=0&id=8dddcf88&scoped=true&lang=css"

import exportComponent from "/go/src/bitbucket.org/VertexSecurity/spark_vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8dddcf88"]])

export default __exports__